import content from '../../../data/content.json';

export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Who We Are */}
        <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
          <div>
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-teal-500"></div>
              <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">Who We Are</span>
            </div>
            <h3
              className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {content.about.title}
            </h3>
            {content.about.whoWeAre.map((text, index) => (
              <p
                key={index}
                className="text-lg text-gray-600 leading-relaxed mb-5"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            ))}
            <div className="flex items-center gap-3 p-4 bg-teal-50 rounded-xl border-l-4 border-teal-500">
              <i className="ri-double-quotes-l text-3xl text-teal-500"></i>
              <p className="text-teal-800 font-medium italic">
                "{content.about.quote}"
              </p>
            </div>
          </div>
          <div className="relative">
            <img
              src={content.about.image}
              alt="Community Support"
              className="w-full h-80 object-cover object-top rounded-2xl"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white rounded-2xl p-6 shadow-lg">
              <div className="text-4xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>24–48h</div>
              <div className="text-sm text-teal-100 mt-1">Response Time</div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-24">
          {content.about.stats.map((stat, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-8 text-center border border-gray-100">
              <div className={`w-14 h-14 flex items-center justify-center mx-auto mb-4`}>
                <i className={`${stat.icon} text-4xl ${stat.color}`}></i>
              </div>
              <div className={`text-5xl font-bold ${stat.color} mb-2`} style={{ fontFamily: 'Playfair Display, serif' }}>
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Personal Support Navigator */}
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-3xl p-10 md:p-16 text-white">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 rounded-full mb-6">
                <i className="ri-compass-3-line text-teal-200"></i>
                <span className="text-sm font-semibold text-teal-100 uppercase tracking-wider">Our Signature Feature</span>
              </div>
              <h3
                className="text-4xl md:text-5xl font-bold leading-tight mb-6"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Your Personal Support Navigator
              </h3>
              <p className="text-teal-100 text-lg leading-relaxed mb-8">
                We don't just refer you — we walk with you. Our dedicated team provides hands-on guidance every step of the way, ensuring no one falls through the cracks.
              </p>
              <button
                onClick={() => {
                  const el = document.getElementById('get-help');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 bg-white text-teal-700 font-semibold rounded-xl hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request a Navigator
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
            <div className="grid grid-cols-1 gap-4">
              {[
                { icon: 'ri-search-eye-line', step: '01', title: 'Understand Your Situation', desc: 'We listen deeply to assess your unique needs and circumstances.' },
                { icon: 'ri-map-2-line', step: '02', title: 'Identify Available Resources', desc: 'We connect you with the right services, programs, and support networks.' },
                { icon: 'ri-list-check-3', step: '03', title: 'Create a Step-by-Step Plan', desc: 'We build a personalized action plan tailored to your goals.' },
                { icon: 'ri-shield-check-line', step: '04', title: 'Stay Supported Throughout', desc: 'We follow up and stay by your side until you\'re stable and thriving.' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-4 bg-white/10 rounded-xl p-4 backdrop-blur-sm">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-teal-300 font-semibold mb-1">Step {item.step}</div>
                    <div className="font-semibold text-white mb-1">{item.title}</div>
                    <div className="text-teal-100 text-sm">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
